var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.667H11.333c-4.666 0-6.666 2.666-6.666 6.666v13.333c0 4 2 6.667 6.666 6.667H22c4.667 0 6.667-2.666 6.667-6.666V9.332c0-4-2-6.667-6.667-6.667ZM11.333 16.332h5.334c.546 0 1 .454 1 1 0 .547-.454 1-1 1h-5.334c-.546 0-1-.453-1-1 0-.546.454-1 1-1ZM22 23.667H11.333c-.546 0-1-.454-1-1 0-.547.454-1 1-1H22c.547 0 1 .453 1 1 0 .546-.453 1-1 1Zm3.333-11.334h-2.666A3.665 3.665 0 0 1 19 8.666V6c0-.547.453-1 1-1 .547 0 1 .453 1 1v2.666c0 .92.747 1.667 1.667 1.667h2.666c.547 0 1 .454 1 1 0 .547-.453 1-1 1Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.9294b21538f6b02e4320849a537c7087.svg";
export { ForwardRef as ReactComponent };